var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.voucherActive)?_c('div',{staticClass:"voucher"},[_vm._t("voucher")],2):_c('div',{staticClass:"voucher"},[_vm._t("voucherActivator")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }